import React from "react";
import { Droppable, Draggable } from "@hello-pangea/dnd";
import FieldPreview from "./FieldPreview";

const FormCanvas = ({ fields, setFields, onMarkInsertIndex, activeInsertIndex }) => {
    const updateField = (id, updatedField) => {
        setFields((prevFields) =>
            prevFields.map((field) => (field.id === id ? updatedField : field))
        );
    };

    const removeField = (id) => {
        setFields((prevFields) => prevFields.filter((field) => field.id !== id));
    };

    return (
        <Droppable droppableId="formCanvas">
            {(provided) => (
                <div
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                    className="space-y-4 bg-gray-50 dark:bg-gray-900 rounded-lg max-h-[75vh] overflow-y-auto"
                >
                    {fields.map((field, index) => (
                        <React.Fragment key={field.id}>
                            {/* Insert marker */}
                            <div className="text-center">
                                <button
                                    className={`text-xs px-2 py-1 rounded transition ${
                                        activeInsertIndex === index
                                            ? "bg-blue-100 text-blue-600 font-semibold"
                                            : "text-gray-500 hover:text-blue-500"
                                    }`}
                                    onClick={() => onMarkInsertIndex(index)}
                                >
                                    + Insert Here
                                </button>
                                {/* <div
                                    className={`h-2 cursor-pointer transition-all duration-200 ${
                                        activeInsertIndex === index ? "border-t-4 border-blue-500" : "border-t border-transparent hover:border-gray-300"
                                    }`}
                                    onClick={() => onMarkInsertIndex(index)}
                                /> */}

                            </div>
                            <Draggable key={field.id} draggableId={field.id} index={index}>
                                {(provided) => (
                                    <div
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        className="bg-white dark:bg-gray-900 rounded shadow hover:shadow-lg transition-shadow duration-300">
                                        <FieldPreview
                                            field={field}
                                            updateField={updateField}
                                            removeField={removeField}
                                        />
                                    </div>
                                )}
                            </Draggable>
                        </React.Fragment>
                    ))}
                    
                    {/* Final insert at end */}
                    <div className="text-center mt-2">
                        {/* <button
                            className={`text-xs px-2 py-1 rounded transition ${
                                activeInsertIndex === fields.length
                                    ? "bg-blue-100 text-blue-600 font-semibold"
                                    : "text-gray-500 hover:text-blue-500"
                            }`}
                            onClick={() => onMarkInsertIndex(fields.length)}
                        >
                            + Insert at End
                        </button> */}
                        {/* <div
                            className={`h-4 cursor-pointer transition-all duration-200 ${
                                activeInsertIndex === fields.length ? "border-t-4 border-blue-500" : "border-t border-transparent hover:border-gray-300"
                            }`}
                            onClick={() => onMarkInsertIndex(fields.length)}
                        /> */}

                    </div>

                    {provided.placeholder}
                </div>
            )}
        </Droppable>
    );
};

export default FormCanvas;
